<template>
	<div class="section-callout margin-top-70 margin-bottom-70">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-6 col-sm-12 col-xs-12 callout-section callout-section-left position-relative">
					<div class="callout-box callout-box-right">
						<div class="section-title margin-bottom-30 margin-top-30">
							<span class="section-title-line"></span>
							<h2>
								<span class="fw-400">{{ $t('Section.CalloutContainerSentenceSx1') }}</span>
								{{ $t('Section.CalloutContainerSentenceSx2') }}?
							</h2>
							<p v-html="$t('Section.CalloutContainerSentenceSx3')"></p>
							<router-link :to="{ name: 'registerUser' }" class="button button-6 margin-top-20">
								{{ $t('Section.CalloutContainerSentenceSx4') }}
							</router-link>
						</div>
					</div>
				</div>
				<div class="col-md-6 col-sm-12 col-xs-12 callout-section callout-section-right position-relative">
					<div class="callout-box callout-box-left">
						<div class="section-title margin-top-30 margin-bottom-30">
							<span class="section-title-line"></span>
							<h2>
								<span class="fw-400">{{ $t('Section.CalloutContainerSentenceDx1') }}</span>
								{{ $t('Section.CalloutContainerSentenceDx2') }}?
							</h2>
							<p>
								{{ $t('Section.CalloutContainerSentenceDx3') }}
							</p>
							<router-link :to="{ name: 'registerLawyer' }" class="button button-6 margin-top-20">
								{{ $t('Section.CalloutContainerSentenceDx4') }}
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CalloutContainer',
}
</script>



// WEBPACK FOOTER //
// src/components/sections/CalloutContainer.vue